import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './plugins/i18n'
import { rootElement } from './config'

if (rootElement) {
  createApp(App).use(i18n).use(store).mount(rootElement)
}
